import { validations } from '@unite-us/app-components';
import { PERIOD_TYPE } from '../constants';

const toDate = (d) => (d instanceof Date ? d : new Date(d));

const isInvalidDate = (d) => {
  if (d == null || d === '') return false;
  return Number.isNaN(toDate(d).getTime());
};

const isSameMonth = (start, end) => {
  const date1 = toDate(start);
  const date2 = toDate(end);
  return date1.getUTCMonth() === date2.getUTCMonth() && date1.getUTCFullYear() === date2.getUTCFullYear();
};

const validateHours = (value) => validations.isRequired(value);

const validateMinutes = (value) => validations.isRequired(value);

export const validateStructuredInteractionForm = (values = {}) => {
  const errors = {};

  const codeConceptError = validations.isRequired(values.codeConceptId);
  if (codeConceptError) errors.codeConceptId = codeConceptError;

  const hoursError = validateHours(values.hours);
  if (hoursError) errors.hours = hoursError;

  const minutesError = validateMinutes(values.minutes);
  if (minutesError) errors.minutes = minutesError;

  if (!errors.hours && !errors.minutes) {
    const hours = parseInt(values.hours, 10) || 0;
    const minutes = parseInt(values.minutes, 10) || 0;

    if (hours === 0 && minutes === 0) {
      errors.minutes = validations.isGreaterThan(values.minutes, null, 0);
    }
  }

  if (values.periodType === PERIOD_TYPE.SINGLE) {
    const singleDateRequired = validations.isRequired(values.singleDate);
    if (singleDateRequired) {
      errors.singleDate = singleDateRequired;
    } else if (isInvalidDate(values.singleDate)) {
      errors.singleDate = 'Enter a valid date';
    }
  }

  if (values.periodType === PERIOD_TYPE.RANGE) {
    const rangeStartRequired = validations.isRequired(values.rangeStart, 'Required');
    if (rangeStartRequired) {
      errors.rangeStart = rangeStartRequired;
    } else if (isInvalidDate(values.rangeStart)) {
      errors.rangeStart = 'Enter a valid start date';
    }

    if (values.rangeStart) {
      const rangeEndRequired = validations.isRequired(values.rangeEnd, 'Required');
      if (rangeEndRequired) {
        errors.rangeEnd = rangeEndRequired;
      }
    }
    if (!errors.rangeEnd && isInvalidDate(values.rangeEnd)) {
      errors.rangeEnd = 'Enter a valid end date';
    }

    if (values.rangeStart && values.rangeEnd && !errors.rangeStart && !errors.rangeEnd) {
      if (!isSameMonth(values.rangeStart, values.rangeEnd)) {
        errors.rangeEnd = 'End date must be in the same month as the start date';
      }
    }
  }

  return errors;
};
